import { useEffect, useRef } from "react"

export default function useCleanup() { 
    const funcs = useRef<(() => void)[]>([])

    useEffect(() => {
      
      return () => {
        funcs.current.forEach(cb => cb())
      }
    }, [])
    

    return (func: () => void) => {
        funcs.current.push(func)
    }
}